import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const NotificationIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="currentColor"
      d="M10.146 3.248a2 2 0 0 1 3.708 0A7 7 0 0 1 19 10v4.697l1.832 2.748A1 1 0 0 1 20 19h-4.535a3.501 3.501 0 0 1-6.93 0H4a1 1 0 0 1-.832-1.555L5 14.697V10c0-3.224 2.18-5.94 5.146-6.752M10.586 19a1.5 1.5 0 0 0 2.829 0zM12 5a5 5 0 0 0-5 5v5a1 1 0 0 1-.168.555L5.869 17h12.263l-.964-1.445A1 1 0 0 1 17 15v-5a5 5 0 0 0-5-5"
    />
  </Icon>
);
